import { OnInit, Component, ViewChild, HostListener, Input } from '@angular/core';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { Store, select } from '@ngrx/store';
import { getGeneralSettings, SelectCurrentUser,SelectPreventativeInProgress, SelectSupplierAddressList, SelectSupplierAddressTypes, SelectTabPermissions } from 'app/profile/store/app.selector';
import { TabPermissions, SupplierPropertyValue, SupplierAddressPropertyValues } from 'app/profile/models/supplier.model';
import { ActivatedRoute } from '@angular/router';
import { FileUploadService } from '../../../common/services/fileUpload.service';
import { AddressGridComponent } from './address-grid/address-grid.component';
import { TslDialog } from '@tesla/ng-tds';
import { TabComponent } from '../tab-component';
import { GeneralSettings } from 'app/profile/models/generic.model';
import { UserDetails } from 'app/profile/models/user.model';
import { GetSupplierAddressContactTypes, GetTabPermissions,GetPreventativeInProgress, GetSupplierAddressListByCode } from 'app/profile/store/app.actions';
import { AddressType } from 'app/profile/models/masterdata.model';
import { I18nService } from 'app/shared/services/i18n.service';
import { AppSettings } from '../../../app.settings';
import { isNullOrUndefined } from 'app/shared/utils/utils';
import { isDataUnderReview } from 'app/shared/constants';

@Component({
    selector: 'app-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit, TabComponent {
    settings: GeneralSettings;
    @Input() data: any;
    supplierCode: string;
    addressModifiedSupplier: SupplierPropertyValue;
    code: string;
    files: File[] = [];
    helpUrl: string;
    showCMTUrl: boolean = false;
    cmtUrl: string;
    wsmUrl: string;
    showManufacturingAddressCMTUrl: boolean = false;
    manufacturingAddresscmtUrl: string;

    tabPermissions: TabPermissions;
    userDetails: UserDetails = null;

    //@ViewChild('addressgrid', { static: false }) addressGrid: AddressGridComponent;
    addressPurpose: AddressType[] = [];
    preventativeHold: boolean = false;
    
    // Data Review Variables
    isDataUnderReview: boolean = false;

    constructor(
        private dialog: TslDialog,
        private store: Store<SupplierState>,
        private activatedRoute: ActivatedRoute,
        private fileUploadService: FileUploadService,
        private translateService: I18nService,
        private config: AppSettings,
    ) {

    }

    isDirty() {
        return this.addressModifiedSupplier ? true : false;
    }

    ngOnInit() {
        this.store.pipe(select(SelectCurrentUser)).subscribe(result => {
            if (result) {
                this.userDetails = result;
            }
        });
        
        this.store.select(getGeneralSettings).subscribe(res => {
            this.settings = res;
            if (res) {
                this.showCMTUrl = this.settings.settings.showCMTLink === "1";
                this.cmtUrl = this.settings.settings.cmtUrl;
                this.helpUrl = this.settings.settings.addressHelpUrl;
                this.showManufacturingAddressCMTUrl = this.settings.settings.showManufacturingAddressCMTUrl === "1";
                this.manufacturingAddresscmtUrl = this.settings.settings.manufacturingAddresscmtUrl;

                this.store.dispatch(new GetSupplierAddressContactTypes());
                this.store.select(SelectSupplierAddressTypes).subscribe(items => {
                    if (items) {
                      this.addressPurpose = items.sort((a, b) => a.id - b.id);
                      this.addressPurpose = this.addressPurpose.filter(purpose=>purpose.name !== 'Off-Site Part Storage Locations');
                    }
                  });
            }
        });
        this.activatedRoute.parent.params.subscribe(params => {
            this.supplierCode = params['code'];
            this.store.dispatch(new GetTabPermissions(this.supplierCode, true));
            this.store.pipe(select(SelectTabPermissions)).subscribe(tabPermissions => this.tabPermissions = tabPermissions);
        });
        this.wsmUrl = `${this.config.WSM_URL}edit/${this.code}/address`;
        if (this.supplierCode) { 
            this.store.dispatch(new GetPreventativeInProgress(this.supplierCode, true));
            this.store.pipe(select(SelectPreventativeInProgress)).subscribe(x => {
              if (x) {
                this.preventativeHold = x;
              }
            });

            // Get Data
            this.store.dispatch(new GetSupplierAddressListByCode(this.supplierCode));
            this.store.select(SelectSupplierAddressList).subscribe(dataList => {
                this.isDataUnderReview = isDataUnderReview(dataList);
                console.log(this.isDataUnderReview);
            });
          }
    }
}
